if (!customElements.get('masonry-toggle')) {
  class MasonryToggle extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(
        new CustomEvent('exo:masonry-toggle', {
          detail: {
            id: this.getAttribute('data-id'),
            index: this.getAttribute('data-index'),
          },
        }),
      );
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
    }
  }

  customElements.define('masonry-toggle', MasonryToggle);
}
